import Model from "../v2/model";

export default class GoogleSignin extends Model {
  static NAME = "user";
  static COLLECTION_NAME = "users";
  static URL = "/api/internal/google_signin";
}
